"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertModal = void 0;
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const modal_1 = require("client/components/modal");
const material_ui_1 = require("material-ui");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const styles = () => core_1.createStyles({
    title: {
        background: "#ff9393",
        padding: "0 .5rem"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%"
    },
    btnContainer: {
        display: "flex",
        justifyContent: "space-between"
    }
});
const decorate = core_2.withStyles(styles);
let AlertModalUnstyled = class AlertModalUnstyled extends React.Component {
    render() {
        const { width = 1000, height = 550, buttonText = "Redirect", cancelText = "Cancel", title = "Empty title", message = "Empty message", onCancel, onClick, classes } = this.props;
        const normalizeDimension = (size) => `${size}px`;
        return (React.createElement(modal_1.Modal, { width: normalizeDimension(width), height: normalizeDimension(height), onCancel: onCancel },
            React.createElement("div", { className: classes.container },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.title },
                        React.createElement(material_ui_1.Typography, { variant: "headline", gutterBottom: true, align: "center" }, title)),
                    React.createElement("div", null,
                        React.createElement(material_ui_1.Typography, { variant: "body1" }, message))),
                React.createElement("div", { className: classes.btnContainer },
                    React.createElement(button_1.MaterialButton, { onClick: onCancel, flat: true }, cancelText),
                    React.createElement(button_1.MaterialButton, { onClick: onClick, flat: true, primary: true }, buttonText)))));
    }
};
AlertModalUnstyled = __decorate([
    mobx_react_1.observer
], AlertModalUnstyled);
exports.AlertModal = decorate(AlertModalUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/alert-modal/alert-modal.tsx
// module id = 3373
// module chunks = 0